<template>
  <div class="login-form">
    <div class="page-description login-row-space">
      {{ 'login_sign_in' | translate }}
      {{ siteTitle }}
    </div>
    <MdtMessage
      v-if="validationMsg.body"
      :title="validationMsg.title"
      :body="validationMsg.body"
      type="danger"
      class="validation-msg" />
    <template v-if="displayLszLogin">
      <div
        class="btn btn-primary lsz-login"
        @click="lszLogin">
        {{ 'general_login' | translate }}
      </div>
    </template>
    <template v-else-if="!twoFactorAuth.email_2fa_is_active">
      <div class="inputs-wrapper">
        <div class="input-wrapper">
          <MdtInput
            ref="inputName"
            v-model="loginData.name"
            :label="'general_username' | translate"
            :required="true"
            class="content-element"
            @keyupEnter="login" />
        </div>
        <div class="input-wrapper">
          <MdtInputPassword
            ref="inputPass"
            v-model="loginData.password"
            :config="{
              label: $options.filters.translate('general_password'),
              required: true,
            }"
            class="content-element"
            @keyupEnter="login" />
        </div>
        <div
          v-if="!isSsoEnabled"
          class="login-content-link pointer"
          @click="$emit('forgotPass')">
          {{ 'login_forgot_user_pass' | translate }}
        </div>
      </div>
      <div class="footer-buttons">
        <div
          class="btn btn-primary"
          @click="login">
          {{ 'general_login' | translate }}
        </div>
        <SsoLogin
          v-if="isSsoEnabled" />
      </div>
    </template>
    <Login2FaEmailAuth v-else :login-data="loginData" />
  </div>
</template>

<script>
import SsoLogin from './SsoLogin.vue';
import Login2FaEmailAuth from './Login2FaEmailAuth.vue';

export default {
  name: 'LoginForm',
  components: {
    SsoLogin,
    Login2FaEmailAuth,
  },
  data() {
    return {
      loginData: {
        name: '',
        password: '',
      },
      validationMsg: {
        title: '',
        body: '',
      },
      loading: false,
      twoFactorAuth: {
        email_2fa_is_active: false,
      },
    };
  },
  computed: {
    siteTitle() {
      return this.$store.state.publicPage.siteTitle;
    },
    isSsoEnabled() {
      return this.$store.getters.bootstrap?.settings?.availableFeatures?.azureSSO?.azureSSOEnabled;
    },
    formTemplate() {
      const bootstrapFormSettings = this.$store.getters
        .bootstrap?.settings?.uiConfig?.applicationForm;
      return bootstrapFormSettings?.template || '';
    },
    displayLszLogin() {
      return this.$store.getters.bootstrap?.settings?.uiConfig?.displayLszLogin;
    },
  },
  methods: {
    login() {
      if (this.loading || !this.isValid()) return;

      this.resetValidationMsg();

      const loginData = {
        username: this.loginData.name,
        password: this.loginData.password,
      };

      this.loading = true;
      this.$store.dispatch('auth/login', loginData).then((data) => {
        const is2FaEmailEnabled = data.email_2fa_is_active;

        if (is2FaEmailEnabled) {
          this.loginData = {
            ...this.loginData,
            email: data.email,
          };
          this.twoFactorAuth.email_2fa_is_active = data.email_2fa_is_active;
        } else {
          const { redirect } = this.$route.query;
          this.$router.push(redirect || '/');
        }
      }).catch((err) => {
        this.validationMsg.title = this.$options.filters.translate('login_invalid_title');
        this.validationMsg.body = err?.response?.data?.detail || '';
      }).finally(() => {
        this.loading = false;
      });
    },
    lszLogin() {
      this.$store.dispatch('auth/lszLogin').then(() => {
        const { redirect } = this.$route.query;
        this.$router.push(redirect || '/');
      }).catch(this.showResponseError);
    },
    resetValidationMsg() {
      this.validationMsg.title = '';
      this.validationMsg.body = '';
    },
    isValid() {
      return Object.values(this.$refs).map((r) => r.isValid()).every((r) => r);
    },
  },
};
</script>

<style lang="scss" scoped>
.inputs-wrapper {
  .input-wrapper {
    .mdt-input {
      margin-bottom: 24px;

      &:last-child .mdt-input {
        margin-bottom: 0;
      }
    }
  }
}
</style>
